import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    overrides: {
        MuiSelect: {
            selectMenu: {
                whiteSpace: 'inherit',
            },
        },
    },
    palette: {
        primary: {
            '100': '#ccd9e0',
            '200': '#99b4c2',
            '300': '#668fa3',
            '400': '#326a85',
            '50': '#e5ecef',
            '500': '#004567',
            '600': '#003752',
            '700': '#00293d',
            '800': '#001b29',
            '900': '#000d14',
            A100: '#ffffff',
            A200: '#99b4c2',
            A400: '#326a85',
            A700: '#00293d',
        },
        secondary: {
            '100': '#f3d0d4',
            '200': '#e8a1a9',
            '300': '#dd737e',
            '400': '#d24452',
            '50': '#f9e7e9',
            '500': '#c71628',
            '600': '#9f1120',
            '700': '#770d18',
            '800': '#4f0810',
            '900': '#270408',
            A100: '#ffffff',
            A200: '#c71628',
            A400: '#c71628',
            A700: '#c71628',
        },
    },
});

export default theme;



// WEBPACK FOOTER //
// ./src/Theme.ts